<template>
    <div>
        <Modal v-model="modal" :closable="false" :mask-closable="false" title="个人信息" width="580" >
            <!--<p slot="header" style="color:#488bea;">
                <Icon type="ios-information-circle"></Icon>
                <span>个人信息</span>
            </p>-->
            <div style="text-align:center">
                <Form ref="formData" :model="formData" :rules="ruleValidate" :label-width="120" style="padding: 20px"> <!--style="width: 500px; padding: 30px"-->
                    <FormItem label="姓名" prop="userName">
                        <Input v-model="formData.userName" disabled readonly :maxlength="10" style="width: 260px;" placeholder="姓名..."/>
                        <span style="margin-left: 10px;line-height: 34px;">{{formData.userName?formData.userName.trim().length:0}}/10</span>
                    </FormItem>
                    <FormItem label="账号" prop="account">
                        <Input v-model="formData.account" :maxlength="20" style="width: 260px;" placeholder="登陆账号..."/>
                        <span style="margin-left: 10px;line-height: 34px;">{{formData.account?formData.account.trim().length:0}}/20</span>
                    </FormItem>
                    <FormItem label="新密码" prop="passWord">
                        <Input v-model="formData.passWord" :maxlength="20" style="width: 260px;" placeholder="密码..."/>
                        <span style="margin-left: 10px;line-height: 34px;">{{formData.passWord?formData.passWord.trim().length:0}}/20</span>
                    </FormItem>
                    <FormItem label="手机号">
                        <Input v-model="formData.phone" :maxlength="11" style="width: 260px;" placeholder="手机号码..."/>
                        <span style="margin-left: 10px;line-height: 34px;">{{formData.phone?formData.phone.trim().length:0}}/11</span>
                    </FormItem>
                    <FormItem label="邮箱">
                        <Input v-model="formData.email" :maxlength="20" style="width: 260px;" placeholder="邮箱..."/>
                        <span style="margin-left: 10px;line-height: 34px;">{{formData.email?formData.email.trim().length:0}}/20</span>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button  size="large" @click="onCancel">取消</Button>
                <Button type="primary" size="large" @click="submit">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>

    import Qs from 'qs';

    import Exit from '../../../utils/exit'

    import { Button, Modal, FormItem, Form, Input} from 'iview';

    export default {
        name: "info",
        props: {
            parentId:{
                default: null,
            },
            modal: {
                default: true
            },
            width:{
                default: 800
            },
            onCancel:{
                type: Function,
                default: () => {}
            }
        },
        components: {
            Button,
            Modal,
            FormItem,
            Form,
            Input,
        },
        data (){
            return {
                formData:{
                    userName:"",
                    account:"",
                    passWord:"",
                    phone:"",
                    email:"",
                },

                //校验规则
                ruleValidate:{
                    userName:[{ required: true, message: '姓名不能为空.', trigger: 'blur' }],
                    passWord:[{ required: true, message: '请输入密码.', trigger: 'blur' },{
                        message:"密码至少为6位数",
                        validator: (rule, value, callback)=> {
                            if (value && value.trim().length && value.trim().length > 5)
                                callback();
                            else
                                callback(rule.message);
                        }
                    }],
                    account:[{ required: true, message: '登陆账号不能为空.', trigger: 'blur' },{
                        message:"账号已存在",
                        validator: (rule, value, callback)=>{
                            if (value && value.trim().length && value.trim().length>4){
                                //this.formData.account = value;
                                this.$request.post("/back/userInfo/isAccountExist?buildingId="+this.$parent.building.buildingId,this.formData,{baseURL:this.$HOST}).then((res)=>{
                                    if (!res.data.code){
                                        if (res.data.result)
                                            callback(rule.message);
                                        else
                                            callback();
                                    }else {
                                        this.$Message.error(res.data.message);
                                    }
                                })
                            }else {
                                rule.message = "账号至少为5位数";
                                callback(rule.message);
                            }
                        }
                    }],
                },
            }
        },

        methods:{
            /**
             * 初始化请求方法
             */
            request (){
                this.$request.get("/back/userInfo?buildingId="+this.$parent.building.buildingId,{baseURL:this.$HOST}).then((res)=>{
                    if (!res.data.code && res.data.result){
                        this.formData = res.data.result;
                    }else {
                        this.$Message.error(res.data.message);
                    }
                })
            },


            submit (){
                this.$refs["formData"].validate((valid) => {
                    if (valid){
                        this.$request.put("/back/userInfo?buildingId="+this.$parent.building.buildingId,this.formData,{baseURL:this.$HOST}).then((res)=>{
                            if (!res.data.code && res.data.result){
                                this.$Message.success("更新成功");
                                Exit.clearCache();
                                location.href="/"
                                //this.$parent._data.infoModal = false;
                            }else {
                                this.$Message.error(res.data.message);
                            }
                        })
                    }
                });
            }
        },

        /**
         * 监听
         */
        watch:{
            modal (value){
                if (value){
                    this.$refs['formData'].resetFields();
                    this.request();
                }

            },
        },
    }
</script>

<style scoped>

</style>
